// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3v3LZ","savePackageButton":"ClientWallet_savePackageButton__255uD"};